import { css } from 'styled-components';
import { FontWeight } from '../../../styled/constants';

interface TextStyleParams {
  size?: string;
  weight?: FontWeight;
  style?: string;
  lineHeight?: string;
  letterSpacing?: string;
  textDecoration?: string;
  textTransform?: string;
}

export const createTextStyles = ({
  size = '15px',
  weight = FontWeight.thin,
  style = 'normal',
  lineHeight = 'normal',
  letterSpacing = 'normal',
  textDecoration = 'none',
  textTransform = 'none'
}: TextStyleParams) => css`
  font-size: ${size};
  font-weight: ${weight};
  font-style: ${style};
  line-height: ${lineHeight};
  letter-spacing: ${letterSpacing};
  text-decoration-line: ${textDecoration};
  text-transform: ${textTransform};
`;

export const headersTagStyles = {
  h1: createTextStyles({ size: '20px' }),
  h2: createTextStyles({ size: '18px', weight: FontWeight.medium }),
  h3: createTextStyles({ size: '16px', weight: FontWeight.medium }),
  h4: createTextStyles({ weight: FontWeight.bold }),
  h5: createTextStyles({ size: '13px', weight: FontWeight.bold }),
  header_bold: createTextStyles({ size: '20px', weight: FontWeight.bold }),
  h4_new: createTextStyles({ size: '18px', weight: FontWeight.bold }),
  h5_new: createTextStyles({ size: '16px', weight: FontWeight.bold }),
  h9: createTextStyles({ size: '22px', weight: FontWeight.bold }),
  h2_new: createTextStyles({ size: '24px', weight: FontWeight.bold }),
  header_bold_new: createTextStyles({ size: '24px', weight: FontWeight.bold }),
  h6: createTextStyles({ size: '15px', weight: FontWeight.bold }),
  h8: createTextStyles({ size: '42px', weight: FontWeight.bold })
};

export const tagStyles = {
  ...headersTagStyles,
  default: createTextStyles({}),
  tab: createTextStyles({ size: '8px', textTransform: 'uppercase' }),
  title_1: createTextStyles({ weight: FontWeight.medium }),
  title_2: createTextStyles({ size: '14px' }),
  title_3: createTextStyles({
    size: '14px',
    weight: FontWeight.medium,
    lineHeight: '17px'
  }),
  title_3_desc: createTextStyles({
    size: '16px',
    weight: FontWeight.medium,
    lineHeight: '17px'
  }),
  title_5: createTextStyles({ size: '13px', weight: FontWeight.bold }),
  title_6: createTextStyles({ weight: FontWeight.bold }),
  body_1: createTextStyles({}),
  body_2: createTextStyles({ size: '14px' }),
  body_3: createTextStyles({ size: '16px' }),
  body_4: createTextStyles({ size: '13px' }),
  p: createTextStyles({ lineHeight: '24px' }),
  caption_1: createTextStyles({ size: '13px' }),
  caption_2: createTextStyles({ size: '11px', weight: FontWeight.medium }),
  caption_4: createTextStyles({ size: '10px', weight: FontWeight.medium }),
  numbers_1: createTextStyles({ size: '24px', weight: FontWeight.medium }),
  numbers_2: createTextStyles({ weight: FontWeight.bold, lineHeight: '17px' }),
  bold: createTextStyles({ weight: FontWeight.bold }),
  numbers_3: createTextStyles({
    weight: FontWeight.medium,
    lineHeight: '19px',
    letterSpacing: '3px'
  }),
  numbers_4: createTextStyles({
    size: '30px',
    style: 'italic',
    weight: FontWeight.medium
  }),
  numbers_5: createTextStyles({
    weight: FontWeight.medium,
    lineHeight: '19px',
    letterSpacing: '2px'
  }),
  title_2_new: createTextStyles({
    size: '20px',
    weight: FontWeight.medium,
    lineHeight: '24px'
  }),
  title_4_new: createTextStyles({
    size: '15px',
    weight: FontWeight.medium,
    lineHeight: '18px'
  }),
  title_3_new: createTextStyles({
    size: '18px',
    weight: FontWeight.medium
  }),
  caption_1_new: createTextStyles({ size: '12px' }),
  title_6_new: createTextStyles({ size: '14px', weight: FontWeight.bold }),
  caption_4_new: createTextStyles({ size: '10px' })
};

export const variantStyles = {
  safariInput: createTextStyles({ size: '16px' }),
  underlined: createTextStyles({ textDecoration: 'underline' }),
  title_uppercase: createTextStyles({
    size: '14px',
    weight: FontWeight.medium,
    style: 'normal',
    textTransform: 'uppercase'
  }),
  caption_italic: createTextStyles({ size: '10px', style: 'italic' }),
  title_3_linked: createTextStyles({
    size: '14px',
    textDecoration: 'underline'
  })
};
